import * as d3 from 'd3'
import { Component, createRef } from 'react'

import { isFirefoxDesktop } from '../../shared/isMobile'
import { retinafy } from '../../shared/retinafy'

var xCache: Record<string, any> = {}

interface CanvasSparklineProps {
  className?: string
  data: number[]
  dateChanges: any
  width: number
  height: number
  changeDomain: number
  change: number
  changeOpacity?: boolean
  shadow?: boolean
  lineColor?: string
  textColor?: string
}

class CanvasSparkline extends Component<CanvasSparklineProps> {
  static defaultProps = {
    changeOpacity: true,
  }

  canvas = createRef<HTMLCanvasElement>()
  declare canvasContext: CanvasRenderingContext2D

  shouldComponentUpdate(nextProps: CanvasSparklineProps) {
    // eslint-disable-next-line eqeqeq
    return nextProps.data != this.props.data || nextProps.width !== this.props.width
  }

  componentDidMount() {
    this.canvasContext = this.canvas.current!.getContext(
      '2d',
      isFirefoxDesktop() ? { willReadFrequently: true } : undefined
    )!
    this._renderCanvas()
  }

  componentDidUpdate() {
    this._renderCanvas()
  }

  render() {
    var { width, height } = this.props
    var className = 'sparkline ' + this.props.className
    return <canvas className={className} width={width} height={height} ref={this.canvas} />
  }

  _renderCanvas = () => {
    var { data, dateChanges, width, height, changeOpacity, shadow, lineColor, textColor } = this.props

    retinafy(this.canvas.current, this.canvasContext, this.props.width, this.props.height)

    // TODO check ci sa zobrazuje posledny den
    var xCacheKey = width + '|' + data.length
    var x = xCache[xCacheKey]
    if (!x) {
      x = d3
        .scaleLinear()
        .range([-1, width + 1])
        .domain([0, data.length])
      xCache[xCacheKey] = x
    }

    var y = d3
      .scaleLinear()
      .range([height - 8, 0])
      .domain(d3.extent(data, (d) => d) as [number, number])

    var changeDomain = this.props.changeDomain
    var opacityChange = Math.min(Math.abs(this.props.change), changeDomain)
    var textOpacity = changeOpacity ? (0.5 + (0.2 / changeDomain) * opacityChange).toFixed(3) : 1

    this.canvasContext.clearRect(0, 0, width, height)

    if (shadow) {
      this.canvasContext.translate(0.5, 0.5)

      this.canvasContext.strokeStyle = 'rgba(34, 38, 47, 0.8)'
      this.canvasContext.beginPath()
      for (let i = 0; i < data.length; i++) {
        this.canvasContext.lineTo(x(i), y(data[i]))
      }
      this.canvasContext.stroke()

      this.canvasContext.fillStyle = 'rgba(34, 38, 47, 0.8)'
      this.canvasContext.textAlign = 'center'
      this.canvasContext.font = '7px Lato'
      Object.keys(dateChanges).forEach((key) => {
        var xPos = x(key)
        if (xPos < 8) {
          return
        }
        this.canvasContext.fillText(dateChanges[key], xPos, height - 1)
      })

      this.canvasContext.translate(-0.5, -0.5)
    }

    this.canvasContext.strokeStyle = lineColor ?? `rgba(255, 255, 255, ${textOpacity})`
    this.canvasContext.beginPath()
    for (let i = 0; i < data.length; i++) {
      this.canvasContext.lineTo(x(i), y(data[i]))
    }
    this.canvasContext.stroke()

    this.canvasContext.fillStyle = textColor ?? `rgba(255, 255, 255, ${textOpacity})`
    this.canvasContext.textAlign = 'center'
    this.canvasContext.font = '7px Lato'
    Object.keys(dateChanges).forEach((key) => {
      var xPos = x(key)
      if (xPos < 8) {
        return
      }
      this.canvasContext.fillText(dateChanges[key], xPos, height - 1)
    })
  }
}

export default CanvasSparkline
